<tsmt-api-error></tsmt-api-error>
<div *ngIf="!hideTabs">
  <div class="home-page-list justify-between header ml-0 mr-0 flex-wrap">
    <div class="search-wrapper flex items-center">
      <div *ngIf="showProductFamilySearch">
        <span class="">
          <span class="input-group">
            <select (change)="onSearchTypeChange($event.target.value)"
              [ngClass]="{'productFamily-searchType': selectedSearchType === 'Product Family', 'job-searchType': selectedSearchType === 'Jobs'}">
              <option *ngFor="let searchType of searchTypes" [value]="searchType">{{searchType}}</option>
            </select>
            <select (change)="onTimeframeChange($event.target.value)" *ngIf="selectedSearchType === 'Product Family'">
              <option *ngFor="let timeframe of timeframes" [value]="timeframe">{{timeframe}}</option>
            </select>
            <span class="input-textbox" *ngIf="selectedSearchType === 'Product Family'">
              <input #Search type="text" autocomplete="off" [(ngModel)]="productFamily" class="k-textbox-productFamily"
                name="search" placeholder="Search..." (keyup)="onKey($event)"
                (keydown.enter)="searchJobList(searchValue, productFamily)">
              <img [hidden]="!showIcon" class="show-icon crossimage-view-productFamily"
                src="../../../assets/images/crossimage.png" alt="clear text" (click)="clearSearchText()">
            </span>
            <span *ngIf="selectedSearchType === 'Jobs'" class="input-textbox flex items-center">
              <input #Search type="text" autocomplete="off" [(ngModel)]="searchValue" class="k-input-inner" name="search"
                placeholder="Search..." (keyup)="onKey($event)"
                (keydown.enter)="searchJobList(searchValue, productFamily)">
              <img [hidden]="!showIcon" class="show-icon crossimage-view-jobs"
                src="../../../assets/images/crossimage.png" alt="clear text" (click)="clearSearchText()">
            </span>
            <span class="input-group-addon" (click)="searchJobList(searchValue, productFamily)">
              <i class="fa fa-search"></i>
            </span>
            <div kendoTooltip tooltipClass="t-tooltip-error" class="t-tooltip  error-icon"
              *ngIf="selectedTimeframe === 'in the past 3 years' || selectedTimeframe === 'in the past year'"
              title="{{timeLimitErrorText}}">
              <em class="t-icon t-icon-error fas fa-info-circle g-pointer-cursor"></em>
            </div>
            <div kendoTooltip tooltipClass="t-tooltip-error" class="t-tooltip  error-icon"
              *ngIf="hasError && selectedSearchType === 'Jobs'" title="{{errorText}}">
              <em class="t-icon t-icon-error fas fa-info-circle g-pointer-cursor"></em>
            </div>
          </span>
        </span>
      </div>
      <div class="t-input-search t-input-group-inside flex !flex-nowrap items-center"
        *ngIf="showSearch && selectedTab === 'Projects'" [ngClass]="{'t-input-error':hasError}">
        <select class="w-[120px] min-w-[120px] !text-indent-0 pl-3 h-8 font-semibold rounded-l-[18px] !bg-[#f2f2f2]" (change)="onSearchCategoryChange($event.target.value)">
          <option *ngFor="let searchCategory of searchCategories" [value]="searchCategory"
            [selected]="selectedSearchCategory === searchCategory">{{searchCategory}}</option>
        </select>
        <div class="t-input-group-append">
          <span class="t-input-group-text t-bg-brand" (click)="searchRecords(Search.value.trim())">
            <span class="t-icon t-icon-white fas fa-search" title="Search"></span>
          </span>
        </div>
        <input #Search type="text" autocomplete="off" [(ngModel)]="searchValue" name="search" placeholder="Search..."
          class="!w-[calc(100%-170px)]" (keyup)="onKey($event)" (keydown.enter)="searchRecords(Search.value.trim())">
        <span class="flex items-center"><i class="fa-solid fa-close" [hidden]="!showIcon" (click)="clearSearchText()"></i></span>
        <div kendoTooltip tooltipClass="t-tooltip-error" class="t-tooltip mr-3" *ngIf="hasError" title="{{errorText}}">
          <em class="t-icon t-icon-error fas fa-info-circle g-pointer-cursor"></em>
        </div>
      </div>
      <div class="t-input-search t-input-group-inside" *ngIf="showSearch && selectedTab !== 'Projects'"
        [ngClass]="{'t-input-error':hasError}">
        <div class="t-input-group-append">
          <span class="t-input-group-text t-bg-brand" (click)="searchRecords(Search.value.trim())">
            <span class="t-icon t-icon-white fas fa-search" title="Search"></span>
          </span>
        </div>
        <input #Search type="text" autocomplete="off" [(ngModel)]="searchValue" name="search" placeholder="Search..."
          (keyup)="onKey($event)" (keydown.enter)="searchRecords(Search.value.trim())">
        <span class="flex items-center"><i class="fa-solid fa-close" [hidden]="!showIcon" (click)="clearSearchText()"></i></span>
        <div kendoTooltip tooltipClass="t-tooltip-error" class="t-tooltip mr-3" *ngIf="hasError" title="{{errorText}}">
          <em class="t-icon t-icon-error fas fa-info-circle g-pointer-cursor"></em>
        </div>
      </div>
      <div *ngIf="showRefresh">
        <button (click)="refreshView()" class="t-btn t-btn-link" title="Click to refresh...">
          <span><i class="fa fa-sync-alt" [ngClass]="refreshSpinClass"></i></span>
          Last Refresh: {{ lastRefresh | date:'short' }}
        </button>
      </div>
      <div kendoTooltip tooltipClass="t-tooltip-info" class="static relative mt-2 ml-3 inline-flex"
        *ngIf="showInfoIconInProjectsTab()"
        title="Please scroll after searching to load more results and then apply filter/sort.">
        <em class="t-icon t-icon-info fas fa-info-circle g-pointer-cursor"></em>
      </div>
    </div>
    <div *ngIf="showCheckboxInProjectsTab()">
      <div class=" t-custom-control t-custom-checkbox t-custom-control-inline relative mt-1 ml-1">
        <input id="select" class="t-custom-control-input" type="checkbox"
          (change)="checkBoxValueChange($event.target.checked)">
        <label class="t-custom-control-label" for="select">Search outside of Region for Projects with Sales Office
          Commission Splits</label>
      </div>
    </div>
    <div>
      <div class="office-selector flex flex-col pr-0" [ngClass]="selectedTab === 'Projects'">
        <div class="help-text">
          <tsmt-inline-alert *ngIf="selectedTab === 'Projects' && currentToggleSelected === ShippingHistoryDisplayMode"
            [alertMessage]="alertMessage" [alertType]="'Informational'" [autoClose]="false">
          </tsmt-inline-alert>
        </div>
        <tsmt-office-selector [hidden]="!(currentToggleSelected && isLoadTsmtOfficeSelector)"
          [selectedToggle]='currentToggleSelected'>
        </tsmt-office-selector>
        <div class="text-right !mt-5" *ngIf="showRefresh">
          <div class="pt-4">
            <label for="my-requests-only" class="font-bold">
              {{appConstants.ONLY_SHOW_MY_REQUESTS}}
              <span kendoTooltip tooltipClass="t-tooltip-info" [tooltipWidth]="150"
                class="t-tooltip static ml-1" filter=".t-tooltip"
                title="The default filter is to only display requests where you are the Project Manager (Credit/PO Ack displays by request contact). Flipping the switch to NO will display all requests for the office chosen in the office selector (Credit/PO Ack does not filter on this). You can filter further in the individual Tile grids as needed. This grid filter will always default to Yes.">
                <em class="t-icon t-icon-info fas fa-info-circle"></em>
              </span>
            </label>
            <kendo-switch [(ngModel)]="onlyShowMyRequests"
              class="font-bold ml-2" [onLabel]="'Yes'" [offLabel]="'No'"
              (ngModelChange)="onShowMyRequestsChange($event)">
            </kendo-switch>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="navigation-tabs nav-tabs-header-only" [ngClass]="{ 'projects' : selectedTab=='Projects' , 'jobs' : selectedTab=='Jobs'
    , 'home' : selectedTab=='Home', 'delegated-jobs-list' : selectedTab=='Delegated Jobs' }">
    <kendo-tabstrip (tabSelect)="onTabSelect($event)" [size]="'small'">
      <kendo-tabstrip-tab *ngFor="let item of tabMenus" [title]="item.title" [disabled]="!item.status"
        [selected]="selectedTab === item.title"></kendo-tabstrip-tab>
    </kendo-tabstrip>
    <div class="relative">
      <router-outlet></router-outlet>
      <tsmt-loader></tsmt-loader>
    </div>
  </div>
</div>

<div *ngIf="hideTabs">
  <router-outlet></router-outlet>
</div>
